 <template>
  <div class="progressDetailPage _boxBg_dark absolute_center">
    <div class="selfClose_btn" @click="close"></div>
    <div class="_boxTitle">当前碳排放量</div>
    <div class="_yellowLine"></div>
    <div class="_innerBox">
      <div class="_dark_icon">本年度变化</div>
      <div class="main_box">
        <div class="text_box ">
          <ul>
            <li>
              <p>本年度同比</p>
              <div>
                <i :style="getImg(dataAllList?.year?.yoy)"></i>
                <p>{{getNum(dataAllList?.year?.yoy)}}</p>%
              </div>
            </li>
          </ul>

        </div>
        <div class="echarts_part" ref="chart1"></div>
      </div>
      <div class="_dark_icon">本年度季变化</div>
      <div class="main_box">
        <div class="text_box ">
          <ul>
            <li>
              <p>本季同比</p>
              <div>
                <i :style="getImg(dataAllList?.quarter?.yoy)"></i>
                <p>{{getNum(dataAllList?.quarter?.yoy)}}</p>%
              </div>
            </li>
            <li>
              <p>本季环比</p>
              <div>
                <i :style="getImg(dataAllList?.quarter?.qoq)"></i>
                <p>{{getNum(dataAllList?.quarter?.qoq)}}</p>%
              </div>
            </li>
          </ul>
        </div>
        <div class="echarts_part" ref="chart3"></div>
      </div>
      <div class="_dark_icon">本年度月变化</div>
      <div class="main_box">
        <div class="text_box ">
          <ul>
            <li>
              <p>本月同比</p>
              <div>
                <i :style="getImg(dataAllList?.month?.yoy)"></i>
                <p>{{getNum(dataAllList?.month?.yoy)}}</p>%
              </div>
            </li>
            <li>
              <p>本月环比</p>
              <div>
                <i :style="getImg(dataAllList?.month?.qoq)"></i>
                <p>{{getNum(dataAllList?.month?.qoq)}}</p>%
              </div>
            </li>
          </ul>
        </div>
        <div class="echarts_part" ref="chart2"></div>
      </div>

      <div class="_dark_icon">本年度日变化</div>
      <div class="main_box">
        <div class="text_box ">
          <ul>
            <li>
              <p>本月日均量</p>
              <div>
                <i :style="getImg(dataAllList?.day?.avg)"></i>
                <p>{{getNum(dataAllList?.day?.avg)}}</p>万吨CO₂
              </div>
            </li>
            <li>
              <p>本月日均量环比</p>
              <div>
                <i :style="getImg(dataAllList?.day?.qoq)"></i>
                <p>{{getNum(dataAllList?.day?.qoq)}}</p>%
              </div>
            </li>
          </ul>
        </div>
        <div class="echarts_part" ref="chart4"></div>
      </div>

    </div>
  </div>
</template>

<script>
import { unwarp } from "@/utils/tools.js";
import getOpt1 from "./chartBar1.js";
import getOpt2 from "./chartBar2.js";
import getOpt3 from "./chartBar3.js";
import getOpt4 from "./chartLine.js";
import { mapGetters } from "vuex";
export default {
  props: ["fromPage"],
  setup(props) {
    const fromPage = props.fromPage;
    return { fromPage };
  },
  data() {
    return {
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      timer: null,
      customerId: this.$store.state.customerId,
      echarts1Data: {},
      echarts2Data: {},
      echarts3Data: {},
      echarts4Data: {},
      echarts1Per: [],
      echarts2Per: [],
      echarts3Per: [],
      echarts4Per: [],
      dataAllList: {},
    };
  },
  watch: {},
  computed: {
    getImg() {
      return (i) => {
        let bg_url;
        if (i && Number(i) < 0) {
          bg_url = require("./img/down.png");
        } else {
          bg_url = require("./img/up.png");
        }
        let url = "url(" + bg_url + ")";
        return {
          backgroundImage: url,
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
          display: "inline-block",
          width: "10px",
          height: "16px",
        };
      };
    },
    getNum() {
      return (i) => {
        if (i === "--") return "--";
        if (i == 100) return Number(i).toFixed(0);
        else return Number(i).toFixed(2);
      };
    },
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
  },
  mounted() {
    this.renderAllChart();
  },
  unmounted() {
    if (this.chart1) {
      this.chart1.dispose();
      this.chart1 = null;
    }
    if (this.chart2) {
      this.chart2.dispose();
      this.chart2 = null;
    }
    if (this.chart3) {
      this.chart3.dispose();
      this.chart3 = null;
    }
    if (this.chart4) {
      this.chart4.dispose();
      this.chart4 = null;
    }
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  methods: {
    close() {
      if (this.fromPage) {
        this.$popup[this.fromPage] && this.$popup[this.fromPage]();
      } else {
        let that = this._.appContext.app;
        this.$popup.close(that);
      }
    },
    async renderAllChart() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      await this.getData();
      this.$nextTick(() => this.renderChart1());
      this.$nextTick(() => this.renderChart2());
      this.$nextTick(() => this.renderChart3());
      this.$nextTick(() => this.renderChart4());
      this.timer = setTimeout(() => {
        this.renderAllChart();
      }, 30000);
    },
    async getData() {
      const carbonUseSituationDetail =
        CONFIG.requestName + this.$apiOpt.carbonUseSituationDetail;
      let res = await this.$apiUtils.get(carbonUseSituationDetail, {
        customerId: this.customerId,
      });
      if (res) {
        const { month, year, day, quarter } = res;
        this.dataAllList = {
          year: {
            yoy: year.yoy,
          },
          month: {
            yoy: month.yoy,
            qoq: month.qoq,
          },
          quarter: {
            yoy: quarter.yoy,
            qoq: quarter.qoq,
          },
          day: {
            avg: day.avg,
            qoq: day.qoq,
          },
        };
        this.echarts1Data = { dateValue: [], value: [] };
        this.echarts2Data = { dateValue: [], value: [] };
        this.echarts3Data = { dateValue: [], value: [] };
        this.echarts4Data = { dateValue: [], value: [] };
        this.echarts1Per = year.changeDataList;
        this.echarts2Per = month.changeDataList;
        this.echarts3Per = quarter.changeDataList;
        this.echarts4Per = day.changeDataList;
        year.dataList.forEach((item1) => {
          this.echarts1Data.dateValue.push(item1.dateValue);
          this.echarts1Data.value.push(item1.value);
        });
        month.dataList.forEach((item2) => {
          this.echarts2Data.dateValue.push(item2.dateValue);
          this.echarts2Data.value.push(item2.value);
        });
        quarter.dataList.forEach((item3) => {
          this.echarts3Data.dateValue.push(item3.dateValue);
          this.echarts3Data.value.push(item3.value);
        });
        day.dataList.forEach((item4) => {
          this.echarts4Data.dateValue.push(item4.dateValue);
          this.echarts4Data.value.push(item4.value);
        });
      }
    },
    renderChart1() {
      if (!this.chart1) {
        this.chart1 = echarts.init(this.$refs.chart1);
      } else {
        this.chart1.dispose();
        this.chart1 = null;
        this.chart1 = echarts.init(this.$refs.chart1);
      }
      let chart1Data = this.echarts1Data;
      unwarp(this.chart1).setOption(getOpt1(chart1Data, this.echarts1Per));
    },
    renderChart2() {
      if (!this.chart2) {
        this.chart2 = echarts.init(this.$refs.chart2);
      } else {
        this.chart2.dispose();
        this.chart2 = null;
        this.chart2 = echarts.init(this.$refs.chart2);
      }
      let chart2Data = this.echarts2Data;
      unwarp(this.chart2).setOption(getOpt2(chart2Data, this.echarts2Per));
    },
    renderChart3() {
      if (!this.chart3) {
        this.chart3 = echarts.init(this.$refs.chart3);
      } else {
        this.chart3.dispose();
        this.chart3 = null;
        this.chart3 = echarts.init(this.$refs.chart3);
      }
      let chart3Data = this.echarts3Data;
      unwarp(this.chart3).setOption(getOpt3(chart3Data, this.echarts3Per));
    },
    renderChart4() {
      if (!this.chart4) {
        this.chart4 = echarts.init(this.$refs.chart4);
      } else {
        this.chart4.dispose();
        this.chart4 = null;
        this.chart4 = echarts.init(this.$refs.chart4);
      }
      let chart4Data = this.echarts4Data;
      unwarp(this.chart4).setOption(getOpt4(chart4Data));
    },
  },
};
</script>

<style lang="scss" scoped>
.progressDetailPage {
  // width: 75%;
  ._boxTitle {
    line-height: 80px;
  }
  ._dark_icon {
    font-size: 20px;
    font-weight: 500;
    line-height: 20px;
  }
  ._innerBox {
    width: 1040px;
    height: 753px;
    background: linear-gradient(
      180deg,
      rgba(108, 151, 255, 0.2) 0%,
      rgba(107, 151, 255, 0.2) 48%,
      rgba(58, 116, 255, 0.1) 100%,
      #0049fa 100%,
      #0049fa 100%
    );
    border: 1px solid #8badff;
    margin: 50px auto 0;
    padding: 20px 40px;
    overflow: auto;
    & > ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 20px 0;
      li {
        width: 460px;
        height: 50px;
        background: linear-gradient(
          225deg,
          rgba(108, 151, 255, 0.2) 0%,
          rgba(58, 116, 255, 0.1) 100%,
          #0049fa 100%
        );
        box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);
        border-radius: 2px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        align-items: center;
        .li_left {
          font-size: 18px;
          font-weight: 500;
          color: #f5a623;
        }
        .li_right {
          font-size: 18px;
          font-weight: 500;
          color: #c8d8ff;
          span {
            font-size: 28px;
            font-weight: 500;
            color: #7ff4b1;
            margin-right: 20px;
          }
        }
      }
    }
    .main_box {
      height: 190px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .text_box {
        margin: 30px 20px 40px;
        width: 331px;
        background: #000000;
        border-radius: 8px;
        border: 1px solid #8ec2ff;
        padding: 0px 30px;
        height: 120px;
        overflow: auto;
        p {
          font-size: 20px;
          font-weight: 600;
          color: #99f5ff;
        }
        & > ul {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          & > li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            &:not(:last-child) {
              &::after {
                content: "";
                display: block;
                width: 291px;
                height: 1px;
                background: linear-gradient(
                  270deg,
                  rgba(201, 251, 255, 0) 0%,
                  #aff8ff 54%,
                  rgba(153, 245, 255, 0) 100%
                );
                position: absolute;
                bottom: -10px;
              }
            }
            & > div {
              display: flex;
              align-items: center;
              justify-content: space-between;
              color: #8de4f3;
              i {
                margin-right: 22px;
              }
              & > p {
                font-family: "dinBold" !important;
                font-size: 32px;
                font-weight: bold;
                color: #8de4f3;
                margin-right: 18px;
              }
            }
          }
        }
      }
      .echarts_part {
        width: 570px;
        height: 190px;
      }
    }
  }
  ._innerBox {
    &::-webkit-scrollbar-thumb {
      background: linear-gradient(180deg, #449eff 0%, #1e5cbb 100%);
    }
    &::-webkit-scrollbar {
      width: 8px;
      border-radius: 6px;
    }
  }
}
</style>